// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"TestimonialSection_testimonial__u8MLg","testimonialGrid":"TestimonialSection_testimonialGrid__dz_Bn"};